// Codice creato da Planet Soluzioni
document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.tab-title');
  const contents = document.querySelectorAll('.tab-content');

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', function () {
      tabs.forEach(t => {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
      });
      contents.forEach(c => {
        c.classList.remove('active');
        c.style.display = 'none';
      });

      this.classList.add('active');
      this.setAttribute('aria-selected', 'true');
      const target = document.getElementById('tab-content-' + index);
      target.classList.add('active');
      target.style.display = 'block';
    });
  });

  document.querySelectorAll('.tab-text-container.shortenable').forEach(container => {
    const btn = container.querySelector('.read-more-btn');
    const content = container.querySelector('.tab-text-inner');

    const lineHeight = parseFloat(getComputedStyle(content).lineHeight);
    const maxHeight = lineHeight * 3;
    if (content.scrollHeight <= maxHeight + 1) {
      btn.style.display = 'none';
    }

    btn.addEventListener('click', () => {
      container.classList.toggle('expanded');
      const expanded = container.classList.contains('expanded');
      btn.textContent = expanded ? 'Chiudi' : 'Leggi di più';
    });
  });
});